import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BackToMore() {
  return (
    <Link
      to="/more"
      data-testid="back-to-more"
      className="flex items-center"
      style={{
        gap: "4px",
        color: "var(--primary)",
        fontWeight: 800,
        fontSize: "15px",
        padding: "16px 20px 4px 20px",
        textDecoration: "none",
      }}
    >
      <ChevronLeft size={20} strokeWidth={2.5} />
      <span>More</span>
    </Link>
  );
}
